module.exports = __webpack_public_path__ + "static/media/to-text-warning.8079a4c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/to-text-warning.png
// module id = 1958
// module chunks = 6